import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-verify-email-confirmation-screen',
  templateUrl: './verify-email-confirmation-screen.component.html',
  styleUrls: ['./verify-email-confirmation-screen.component.scss'],
})
export class VerifyEmailConfirmationScreenComponent {}
